<template>
  <div
    style="background-color: white"
    class="p-4"
  >
    <b-modal
      id="modal-excluir-aluno"
      title="Confirmação de exclusão de Aluno"
      cancel-title="cancelar"
      cancel-variant="outline-secondary"
      ok-variant="danger"
      ok-title="Deletar"
      centered
      @ok="deletarAluno()"
    >
      <b-card-text>
        <slot name="content-message">
          Tem certeza de que deseja <strong>excluir</strong> esse Aluno?
        </slot>
      </b-card-text>
    </b-modal>
    <b-modal
      id="modal-add-aluno"
      ok-only
      ok-title="Salvar"
      centered
      size="lg"
      title="Criar Aluno"
      @ok="salvarCurso()"
    >
      <b-form-group
        label="Nome Aluno"
        label-for="basicInput"
      >
        <b-form-input
          id="basicInput"
          v-model="nomeAlunoNOVO"
          placeholder="Nome Aluno"
        />
      </b-form-group>
      <b-form-group
        label="Email Aluno"
        label-for="basicInput"
      >
        <b-form-input
          id="basicInput"
          v-model="emailAlunoNOVO"
          placeholder="Email Aluno"
        />
      </b-form-group>
      <b-form-group
        label="Telefone Aluno"
        label-for="basicInput"
      >
        <b-form-input
          id="basicInput"
          v-model="telefoneAlunoNOVO"
          placeholder="Telefone Aluno"
        />
      </b-form-group>
      <div class="mt-3">
        <label for="input-file">Foto de Perfil</label>
        <input-file-custom
          id="input-file"
          @atualizarImagem="updatedImagem($event)"
        />
      </div>

    </b-modal>
    <b-modal
      id="modal-add-aluno-import"
      centered
      size="lg"
      title="Cadastro de Alunos"
      hide-footer
    >
      <b-tabs
        content-class="pt-1"
        fill
      >
        <b-tab
          active
          title="Importa Alunos"
        >
          <b-card-text>Aqui voce pode importa alunos de forma mais pratica e dinamica, sem precisar cadastrar 1 por 1 , qualquer duvida que tiver acesse a aba ao lado 'Como usar ?' e siga o passo a passo.</b-card-text>
          <b-card-text class="font-weight-bold">
            Selecione o arquivo para realizar a importação.
          </b-card-text>
          <div class="mt-2">
            <input
              ref="fileInput"
              type="file"
              style="display: none"
              accept=".xlsx"
              @change="uploadFile"
            >
            <b-button
              class="bg-danger"
              style="border: none"
              @click="openFileInput"
            >
              <feather-icon
                icon="FileIcon"
                color="white"
              /> Arquivo
            </b-button>
          </div>
        </b-tab>
        <b-tab

          title="Como usar?"
        >
          <b-card-text>
            Para importa alunos, voce precisa ter uma planilha com o padrao abaixo:
            <div class="mb-1">
              <img
                style="height: 300px"
                src="../../../assets/images/aluno/img-tb-aluno.png"
                alt="Imagem de exemplo"
              >
            </div>
            <a
              style="border: none"
              href="https://dkplayer.s3.sa-east-1.amazonaws.com/CursoBooster/tb_aluno.xlsx"
              download="tb_aluno.xlsx"
            >
              Baixar modelo
            </a>

          </b-card-text>
          <b-card-text>
            Preencha a tabela com os dados de seus alunos, depois va na aba Importa Alunos e seleciona o arquivo.
            Lembre-se que o padrao da tabela deve estar igual vimos no exemplo.
          </b-card-text>
        </b-tab>
      </b-tabs>

    </b-modal>

    <b-row>
      <b-row>
        <b-col
          md="2"
          sm="4"
          class="my-1"
        >
          <h3>Alunos</h3>
        </b-col>
      </b-row>
      <b-col
        md="2"
        sm="4"
        class="my-1"
      >
        <b-form-group
          class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Mostrar</label>
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            :options="pageOptions"
            class="w-50"
          />
        </b-form-group>
      </b-col>
      <b-col
        class="my-1 p-1 d-flex justify-content-end"
        style="
    gap: 1%;
"
      >
        <b-button
          v-b-modal.modal-add-aluno
          class="bg-danger"
          style="border: none"
        >
          + Aluno
        </b-button>
        <b-button
          v-b-modal.modal-add-aluno-import
          class="bg-danger"
          style="border: none"
        >
          <feather-icon
            icon="FileIcon"
            color="white"
          /> Import
        </b-button>
      </b-col>
      <b-col cols="12">
        <b-table
          striped
          hover
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          :items="alunos"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #cell(user_photo_url)="data">
            <b-avatar :src="data.value" />
          </template>

          <template #cell(user_ativo)="data">
            <b-badge :variant="user_ativo[1][data.value]">
              {{ user_ativo[0][data.value] }}
            </b-badge>
          </template>
          <template #cell(Ações)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item @click="editAluno(data.item.id)">
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">Editar</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                @click="showModalDelete1(data.item)"
              >
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">Deletar</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>

        </b-table>
      </b-col>
      <b-col
        cols="12"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          size="sm"
          class="my-0"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BFormTextarea,
  BCardText,
  BModal,
} from 'bootstrap-vue'
import InputFileCustom from '@/views/App/Cursos/InputFileCustom.vue'
import { useApi, useApiAWS } from '@/composables/useApi'

const apiBack = useApi()
const apiAws = useApiAWS()

export default {
  components: {
    BModal,
    InputFileCustom,
    BFormTextarea,
    BCardText,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
  },
  data() {
    return {
      selectedFile: null,
      alunoSelecionado: {},
      alunos: [],
      nomeAlunoNOVO: '',
      emailAlunoNOVO: '',
      telefoneAlunoNOVO: '',
      imagemAlunoNOVO: '',
      capa: '',
      perPage: 5,
      pageOptions: [3, 5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        // {
        //   key: 'id', label: 'Id',
        // },
        { key: 'user_photo_url', label: 'Capa' },
        { key: 'user_name', label: 'Nome', sortable: true },
        { key: 'user_ativo', label: 'Status', sortable: true },
        { key: 'Ações', label: 'Ações', sortable: true },
      ],

      user_ativo: [{
        1: 'Ativo', 0: 'Inativo',
      },
      {
        0: 'light-primary', 1: 'light-success',
      }],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    getUserData: {
      get() {
        const newUserData = JSON.parse(localStorage.getItem('userData'))
        if (newUserData !== null) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.domainUser = newUserData.user_domain
          return newUserData
        }
        return {}
      },
      set(value) {
        localStorage.setItem('userData', JSON.stringify(value))
      },
    },
  },
  async mounted() {
    // Set the initial number of items
    this.totalRows = this.alunos.length
    await this.listarAluno()
  },
  methods: {
    editAluno(id) {
      return this.$router.push(`/editAluno/${id}`)
    },
    showModalDelete1(item) {
      this.alunoSelecionado = item
      this.$bvModal.show('modal-excluir-aluno')
    },
    async listarAluno() {
      await apiBack.get(`/getAlunos?id_user=${this.getUserData.id}`)

        .then(data => {
          console.log(data.data)
          this.alunos = data.data
        })
        .catch(err => console.error(err))
    },
    async deletarAluno() {
      await apiBack.delete(`/usuario/${this.alunoSelecionado.id}`)
        .then(async response => {
          console.log(response)
          this.deletarAws()
          this.listarAluno()
          this.$message({
            type: 'success',
            message: 'Deletado com sucesso',
          })
        })
        .catch(error => console.log(error))
    },
    async deletarAws() {
      await apiAws.delete('/remover-folder', {
        params: {
          folder_key_name: this.alunoSelecionado.user_file_key,
        },
      })
        .then(res => {
          console.log(res)
        })
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    selecionaImagem(capa) {
      this.capa = capa
    },
    async onFileChange(event) {
      const file = event.target.files[0]
      // await this.uploadAvatarChat(file)
      this.capa = file
    },
    async salvarCurso() {
      await this.uploadCapaCurso()
      await apiBack.post('/addAluno', {
        nome: this.nomeAlunoNOVO,
        email: this.emailAlunoNOVO,
        phone: this.telefoneAlunoNOVO,
        foto: this.capa,
        senha: `${this.telefoneAlunoNOVO}`,
        status: 1,
        id_user: this.getUserData.id,
      })
        .then(() => {
          this.listarAluno()
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })
        .catch(err => console.error(err))
    },
    async uploadCapaCurso() {
      const formData = new FormData()
      formData.append('video', this.capa)
      formData.append('caminho', `${this.getUserData.user_file_key}`)
      await apiAws.post('/thumb', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(async response => {
        this.capa = response.data.data.fileUrl
      }).catch(err => {
        console.log(err)
      })
    },
    openFileInput() {
      this.$refs.fileInput.click()
    },
    async uploadFile(event) {
      // eslint-disable-next-line prefer-destructuring
      this.selectedFile = event.target.files[0]
      try {
        const formData = new FormData()
        formData.append('file', this.selectedFile)
        console.log(this.selectedFile)
        const response = await apiBack.post(`/upload-aluno/${this.getUserData.id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        console.log(response.data)
        this.listarAluno()
        this.$message({
          type: 'success',
          message: 'Alunos adicionados com sucesso.',
        })
      } catch (error) {
        console.error(error)
      }
    },
    updatedImagem(event) {
      console.log(event)
      this.capa = event
    },
    downloadFile() {
      const filePath = '../../../assets/images/aluno/tb_aluno.xlsx'// Caminho do arquivo
      console.log(filePath)
      // Crie um elemento de link para iniciar o download
      const a = document.createElement('a')
      a.href = filePath
      a.download = 'tb_aluno.xlsx' // Nome desejado para o arquivo
      a.style.display = 'none'

      // Adicione o elemento de link ao DOM e clique nele
      document.body.appendChild(a)
      a.click()

      // Remova o elemento de link
      document.body.removeChild(a)
    },
  },
}
</script>
